import API from '../data/api';

class ClockouController {
    data = API.Instance();
    context = null;

    async initialize() {}

    async componentDidMount() {
        this.context = await this.data.fetchContext();
        await this.initialize();
    }
}

export default ClockouController;
